import React from "react";

type Props = {
  status?: string;
  completionPercentage?: number | null;
  score?: number | null;
  compact?: boolean; // optional: smaller bars if true
};

function Bar({ percent, label, testId }: { percent: number; label: string; testId: string }) {
  const p = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className="w-full">
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-sm text-muted-foreground">{label}</span>
        <span className="text-sm font-medium" data-testid={testId}>{p}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        <div className="h-2 rounded-full bg-primary transition-all" style={{ width: `${p}%` }} />
      </div>
    </div>
  );
}

export default function AuditProgressAndScore({ status, completionPercentage, score, compact }: Props) {
  const s = (status || '').toString().toLowerCase();
  const isInProgress = s === "draft" || s === "in_progress" || s === "assigned";
  const showCompletion = isInProgress && typeof completionPercentage === "number";
  // Only show score once submitted or later (not for draft/assigned/in_progress)
  const showScore = typeof score === "number" && !isInProgress;

  if (!showCompletion && !showScore) return null;

  return (
    <div className={compact ? "space-y-2" : "space-y-3"}>
      {showCompletion && (
        <Bar
          percent={completionPercentage ?? 0}
          label="Completion"
          testId="audit-completion-value"
        />
      )}
      {showScore && (
        <Bar
          percent={Number(score!.toFixed(1))}
          label="Score"
          testId="audit-score-value"
        />
      )}
    </div>
  );
}
